import React, { useEffect, useState } from "react";
import { Button, Text } from "components";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function CompanyLedgerAdd() {
  const [visible, setvisible] = useState(true);
  const [option, setOptions] = useState([]);
  let navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    getCompanyLedgerType();
  }, []);

  const getCompanyLedgerType = () => {
    axios
      .post("/api/purple-fusion/companyledger/ledgertype/get", {}, headers)
      .then((response) => {
        setOptions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Company Data:", error);
      })
      .finally(() => {});
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(" Ledger Name is required"),
    ledger_type_id: Yup.string().required("Ledger Type is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      ledger_type_id: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });
  const handleFormSubmit = (values) => {
    console.log(values);

    axios
      .post("/api/purple-fusion/companyledger/create", values, headers)
      .then((response) => {
        console.log(response.data);
        const message = response.data.message;
        response.data.status
          ? toast.success(message, {
              autoClose: 2000,
              onClose: () => {
                setvisible(false);
                navigate(`/companysettingsall`);
              },
            })
          : toast.error(message, {
              autoClose: 2000,
              onClose: () => {},
            });
      })
      .catch((error) => {
        console.log(error);
        setvisible(false);
        navigate("*");
      });
  };
  const customStyle = {
    content: {
      width: "50%",
      height: "50%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  };

  return (
    <div>
      <div>
        <Modal isOpen={visible} style={customStyle} onRequestClose={() => {}}>
          <form onSubmit={formik.handleSubmit}>
            <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full p-4">
              <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                <div className="flex flex-1 flex-col gap-[19px] justify-start md:px-5 w-full">
                  <div>
                    <div className="flex flex-row items-center justify-start ">
                      <div className="flex flex-row  items-start justify-between w-full ">
                        <Text
                          className="mt-[5px] md:text-xl sm:text-[24px] text-[20px] text-black-900 tracking-[0.20px]"
                          size="txtInterMedium24"
                        >
                          Add New Ledger
                        </Text>
                      </div>
                      <div className="flex flex-row items-center justify-end ml-auto top-2 ">
                        <Button
                          className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]"
                          shape="round"
                          color="blue_A700"
                          size="base"
                          variant="fill"
                          type="submit"
                        >
                          Save
                        </Button>
                        <Button
                          className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]"
                          shape="round"
                          color="white"
                          size="base"
                          variant="fill"
                          se
                          onClick={() => {
                            setvisible(false);
                            navigate(`/companysettingsall`);
                          }}
                        >
                          ╳
                        </Button>
                      </div>
                    </div>
                    <ToastContainer />
                    <div className="flex flex-col items-center justify-start mt-4 w-full">
                      <div className="md:gap-5 gap-[75px] grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                        <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                          <Text
                            className=" md:text-[22px] text-black-900 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black700"
                          >
                            <span className="text-black-700 font-inter font-small text-sm">
                              Ledger Name
                            </span>
                            <span className="text-red-A700 font-inter font-samll text-sm">
                              *
                            </span>
                          </Text>
                          <input
                            name="name"
                            type="text"
                            placeholder=" Enter Ledger Name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-full text-xs"
                          ></input>
                          {formik.touched.name && formik.errors.name ? (
                            <div className="text-red-500 text-sm">
                              {formik.errors.name}
                            </div>
                          ) : null}
                        </div>
                        <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full">
                          <Text
                            className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                            size="txtInterMedium20Black900"
                          >
                            <span className="text-black-700 font-inter font-small text-sm">
                              Ledger Type
                            </span>
                            <span className="text-red-A700 font-inter font-small text-sm">
                              *
                            </span>
                          </Text>

                          <Select
                            name="ledger_type_id"
                            options={option
                              .filter((resstate) => resstate.isactive === true)
                              .map((resstate) => ({
                                label: resstate.name,
                                value: resstate.id,
                              }))}
                            className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full text-xs"
                            onChange={(selectedOption) => {
                              formik.setFieldValue(
                                "ledger_type_id",
                                selectedOption.value
                              );
                            }}
                            onBlur={formik.handleBlur}
                            placeholder="Select Ledger Type"
                          />
                          {formik.touched.ledger_type_id &&
                          formik.errors.ledger_type_id ? (
                            <div className="text-red-500 text-sm">
                              {formik.errors.ledger_type_id}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      </div>
    </div>
  );
}

export default CompanyLedgerAdd;
